import request from "../request";
import sysrequest from "../sysrequest";
// 获取案件分析列表

const api = {
  // 案件訪視統計（Tab 1）
  getCaseAnalysisVisit(data) {
    const obj = {
      url: "/bid/demo_v1/analysis/case/visit/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 匯出案件訪視統計
  exportCaseAnalysisVisit(data) {
    const obj = {
      url: "/bid/demo_v1/analysis/case/visit/export/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 案件完成統計（Tab 2）
  getCaseAnalysisComplete(data) {
    const obj = {
      url: "/bid/demo_v1/analysis/case/complete/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 匯出案件完成統計
  exportCaseAnalysisComplete(data) {
    const obj = {
      url: "/bid/demo_v1/analysis/case/complete/export/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 記錄使用者查詢行為
  userQueryRecord(data) {
    const obj = {
      url: "/bid/demo_v1/analysis/user_query/record/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  // 使用者查詢行為統計
  userQueryStats(data) {
    const obj = {
      url: "/bid/demo_v1/analysis/user_query/stats/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },

  userQueryStats_export(data) {
    const obj = {
      url: "/bid/demo_v1/analysis/user_query/stats/export/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};

export default api;
